<template>
  <div class="hidden" />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { getUrlParam, getTemplateData } from '@/utils'
import { useThemeStore, useBundleStore, useProductsStore } from '@/stores'
import { useFueled } from '@/services/fueled'
import { useBreakpoints } from '@/plugins/global.01-breakpoints'
import ProductModalWrapper from '@/components/products/product-modal-wrapper.vue'

const { drawer, modal } = useThemeStore()
const { sm } = useBreakpoints()
const bundle = useBundleStore()
const productsStore = useProductsStore()
const variant = getUrlParam('variant')
const { productViewed } = useFueled()

if (variant) {
  const mapping = getTemplateData('#json-variant-map')?.[variant]
  if (mapping) {
    bundle.setSelectedSize(mapping.size)
    bundle.plan = mapping.plan
  }
} else {
  bundle.readUrlParams()
}

const openPdpModal = () => {
  const hash = String(window.location.hash).slice(1)
  const product = hash.length && productsStore.productList.find(p => p.handle === hash)
  if (product) {
    productViewed(product)
    const shell = sm.value ? drawer : modal
    shell.open(ProductModalWrapper, { bundleProductId: product.bpId })
  }
}

window.addEventListener('replaceState', openPdpModal)
onMounted(openPdpModal)
</script>
